<div class="filter-container">
    <input 
      type="text" 
      [formControl]="filterControl"
      [placeholder]="placeholder"
      class="filter-input">
    <button *ngIf="filterControl.value" 
            (click)="clearFilter()" 
            class="clear-btn">
      ×
    </button>
  </div>
